import React from "react";
import classNames from "classnames";

import Button from "../button/ButtonController.jsx";
import Logo from "../logo/Logo.jsx";
import Overlay from "../overlay/OverlayController.jsx";
import { TabButton } from "../tabs/Tabs.jsx";
import "./styles.styl";

export default function Dialog(props) {
  const {
    className,
    text,
    buttonText,
    logoSmallUrl,
    colorSecondary,
    onButtonClick,
    active,
    children,
    onCloseDialogClick,
    setShowRegistrationForm,
  } = props;

  const handleClose = () => {
    onCloseDialogClick && onCloseDialogClick();
    setShowRegistrationForm && setShowRegistrationForm();
  };
  return (
    <Overlay className={classNames("dialog", className)} active={active}>
      {onCloseDialogClick && (
        <div className="dialog__close">
          <TabButton id="close" className="dialog__close">
            <div onClick={handleClose}>×</div>
          </TabButton>
        </div>
      )}
      <div className="dialog__logo-container">
        <Logo className="dialog__logo" logoSmallUrl={logoSmallUrl} />
      </div>
      <div className="dialog__text">{text || children}</div>
      {buttonText && (
        <Button
          onClick={onButtonClick}
          className="dialog__button"
          colorsecondary={colorSecondary}
          logosmallurl={logoSmallUrl}
        >
          {buttonText}
        </Button>
      )}
    </Overlay>
  );
}
